<template>
  <group-details
    :id="$router.currentRoute.params.orgId"
    :display-invite="false"
    :can-change-group="true"
    :display-org-flags="true"
  />
</template>

<script>
import GroupDetails from '../../components/access/GroupDetails';


export default {
  name: 'org-details-management',
  components: {
    GroupDetails,
  },
};
</script>

<style scoped>
</style>